import React from 'react'
import { motion } from 'framer-motion'
import tick from '../../assets/confirmTb.svg'
import uploadFile from '../../assets/fileFormat.svg'

import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import Modal from "../../myfin_v2/elements/Modal";
import ImageCarousel from "../../myfin_v2/components/ImageCarousel";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { Button } from "../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import tbFormat1 from "../../myfin_v2/assets/imgs/tbFormat1.png";
import tbFormat2 from "../../myfin_v2/assets/imgs/tbFormat2.png";
import tbFormat3 from "../../myfin_v2/assets/imgs/tbFormat3.png";



const FileFormat = (props) => {
    const screen = {
        width: '100%',
        height: '100%',
        position: 'fixed',
        zIndex: '999',
        backgroundColor: '#11111199',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        inset: 0,  


    }
    const container = {
        // minHeight:'60vh',
        borderRadius: '10px',
        maxHeight: '90vh',
        minWidth: '560px',
        padding: '2rem 5rem',
        zIndex: '15',
        backgroundColor: 'white',
        overflowX: 'hidden',
        overflowY: 'auto',
    }

    const head = {
        display: 'flex'
    }


    const header = {
        fontSize: '1.5rem',
        fontWeight: '700'
    }
    const para = {
        fontSize: '14px',
        fontWeight: '500',
        marginTop: '6px',
        margin: '0',
        color: 'var(--clr-accent)'
    }


    // const footSelect ={
    //     display:'flex',
    //     justifyContent:'center',
    //     alignItems:'center',
    //     marginTop:'1rem'
    // }


    return (
        <>
            <Modal
                title="Trial Balance Format"
                bodycss={`${commoncss.unsetPadding} ${commoncss.noOverflow}`}
                width="550px"               
                headerActions={
                    <CloseIcon
                        onClick={() => { props.setViewFormat(false) }}
                        className="clickable"
                    />
                }
                onClose={() => console.log("Modal Closed")}
            >
                <div>
                    <ImageCarousel
                        images={[
                            { src: tbFormat1, alt: "tbFormat1" },
                            { src: tbFormat2, alt: "tbFormat2" },
                            { src: tbFormat3, alt: "tbFormat3" },
                        ]}
                        // autoPlay
                        // interval={4000}
                        // className=" mx-auto"
                    />
                </div>
            </Modal>
            <motion.div style={screen}
                className="screenDiv"
                // onClick={handleClose}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                hidden
            >
                {/* <div style={{display:'flex',flexDirection:'column'}}> */}

                <motion.div style={container}
                    className={commoncss.hideScroll}
                    initial={{ y: '-5vh' }}
                    animate={{ y: 0 }}
                >
                    <div style={head}>
                        <div >
                            <h2 style={header}>Trial Balance Format</h2>
                            <p style={para}><img src={tick} /> Please Ensure the header columns are in the first row.</p>
                            <p style={para}><img src={tick} /> Remove Sub-total values in between or at the end.</p>
                            <p style={para}><img src={tick} /> Mandatory columns must include Ledger Codes,Ledger Names & Amount.</p>
                        </div>
                        <div style={{ paddingTop: '13px', marginLeft: 'auto' }}>
                            <h5 style={{ color: 'var(--clr-accent)', fontSize: '1rem', fontWeight: '700', cursor: 'pointer' }}
                                onClick={() => { props.setViewFormat(false) }}
                            >Close</h5>
                        </div>
                    </div>

                    <div style={{ marginTop: '1rem', transform: 'scale(0.9)', display: 'grid', margin: 'auto', justifyContent: 'center' }}>
                        <img src={uploadFile} />


                    </div>
                </motion.div>
                {/* </div> */}


            </motion.div>
        </>
    )
}

export default FileFormat
